(function ($) {
	'use strict';

	$(function () {
		Array.from(document.querySelectorAll('.js-share')).forEach(shareItem => {
			const shareLink = shareItem.querySelector('.js-share__link');
			const shareItems = shareItem.querySelector('.js-share__links');

			shareLink.addEventListener('click', ev => {
				ev.preventDefault();

				shareItems.classList.toggle('meta-links__share--hidden');
			});
		});
	});
})(jQuery);
